import {
    type IPurchaseOrderSovData,
    type IPurchaseOrderSovGroup,
    type IPurchaseOrderSovLine,
    type IPurchaseOrderSovResponse,
} from "entity/purchaseOrder/PurchaseOrderContinuationSheet/PurchaseOrderContinuationSheet.types";

export function dtoToPurchaseOrderSov(
    dto: IPurchaseOrderSovResponse | null | undefined,
): IPurchaseOrderSovData | null {
    if (dto == null) {
        return null;
    }

    const groups: IPurchaseOrderSovGroup[] = (dto.groups ?? []).map((g) => ({
        id: g.id,
        name: g.name ?? "",
        displayOrder: g.displayOrder,
    }));

    const lines: IPurchaseOrderSovLine[] = (dto.lines ?? []).map((l) => ({
        purchaseOrderLineItemId: l.purchaseOrderLineItemId,
        scheduleOfValueLineItemId: l.scheduleOfValueLineItemId,
        groupId: l.scheduleOfValueGroupId ?? null,
        title: l.description ?? "",
        costCodeTitle: l.costCodeTitle ?? "",
        scheduledValue: l.scheduledValue,
        approvedChanges: l.approvedChanges,
        fromPreviousApplication: l.fromPreviousApplication,
        thisPeriod: l.thisPeriod,
        materialsPresentlyStored: l.materialsPresentlyStored,
        retainagePercent: l.retainagePercent,
        displayOrder: l.displayOrder,
    }));

    return { groups, lines };
}
